import {FilterTab} from "./tabs";
import {ICase} from "../../../types/Case";

const TABS_STATUS_MAPPING = {
  pairing: ['processing', 'todo'],
  processing: ['accept', 'assigned'],
  ended: ['completed', 'rejected'],
}

export const filterCasesByTab = (cases: ICase[], tab: FilterTab) => {
  const allowedStatus = TABS_STATUS_MAPPING[tab]
  return cases.filter(c => allowedStatus.includes(c.status))
}
